import { LoginScreen, useLoginStore } from '@finn/platform-modules';
import { ModalKey, useOpenModal } from '@finn/ua-modals';
import { CookieKeys, getClientCookie, useSession } from '@finn/ui-utils';
import { useEffect } from 'react';

export const useSetRegistrationIncomplete = ({ triggerModal = false }) => {
  const [session] = useSession();
  const email = session?.user?.email;
  const firstName = session?.user?.hs_first_name;
  const setLoginScreen = useLoginStore((state) => state.setLoginScreen);
  const setIsRegistrationIncomplete = useLoginStore(
    (state) => state.setIsRegistrationIncomplete
  );
  const isRegistrationIncomplete = useLoginStore(
    (state) => state.isRegistrationIncomplete
  );
  const openModal = useOpenModal();

  useEffect(() => {
    const registrationDataSubmitted =
      getClientCookie(CookieKeys.REGISTRATION_DATA_SUBMITTED) === email;

    if (
      email &&
      !firstName &&
      !registrationDataSubmitted &&
      !isRegistrationIncomplete
    ) {
      setIsRegistrationIncomplete(true, email);
      setLoginScreen(LoginScreen.completeRegistration);
      if (triggerModal) {
        openModal(ModalKey.LOGIN);
      }
    } else if (
      email &&
      (firstName || registrationDataSubmitted) &&
      isRegistrationIncomplete !== false
    ) {
      setIsRegistrationIncomplete(false, email);
    }
  }, [
    email,
    firstName,
    isRegistrationIncomplete,
    setIsRegistrationIncomplete,
    setLoginScreen,
    triggerModal,
    openModal,
  ]);
};
